// extracted by mini-css-extract-plugin
export default {"image":"integration-jobbiplace_image__AmudW","imageWrapper":"integration-jobbiplace_imageWrapper__OMFar","imageWrapper_white":"integration-jobbiplace_imageWrapper_white__Tbp8+"};